import { ArrowDownCircle, ArrowUpCircle } from "lucide-react";

import { CORES, reais } from "../lib/formato";

function Lista({ titulo, icone: Icone, itens, campo, cor, rodape, vazio }) {
  const max = Math.max(...itens.map((i) => i.total), 1);
  return (
    <section className="rounded-2xl border bg-card p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-3"><Icone className="w-5 h-5" style={{ color: cor }} /><h2 className="font-bold">{titulo}</h2></div>
      {!itens.length ? <p className="text-sm text-muted-foreground">{vazio}</p> : (
        <ul className="space-y-2.5">
          {itens.slice(0, 8).map((i) => (
            <li key={i[campo]}>
              <div className="flex items-baseline gap-2 text-sm">
                <span className="flex-1 truncate">{i[campo]}</span>
                {rodape?.(i)}
                <span className="tabular-nums font-semibold">{reais(i.total)}</span>
              </div>
              <div className="h-2 rounded-full bg-muted mt-1 overflow-hidden flex gap-px">
                <div className="h-full" style={{ width: `${(i.realizado / max) * 100}%`, background: cor }} />
                <div className="h-full opacity-40" style={{ width: `${(i.previsto / max) * 100}%`, background: cor }} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

/** De onde veio e para onde foi o dinheiro do período. */
export default function Quebras({ dados }) {
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Lista titulo="Entradas por forma de pagamento" icone={ArrowUpCircle} cor={CORES.entrada} campo="forma"
        itens={dados?.entradas_por_forma || []} vazio="Nenhuma venda entra na conta neste período."
        rodape={(i) => (i.taxa > 0 ? <span className="text-[11px] text-muted-foreground tabular-nums">taxa {reais(i.taxa)}</span> : null)} />
      <Lista titulo="Saídas por classificação" icone={ArrowDownCircle} cor={CORES.saida} campo="classificacao"
        itens={dados?.saidas_por_categoria || []} vazio="Nenhuma despesa paga ou a pagar neste período." />
    </div>
  );
}
